export enum LocationProviderType {
  AWS = 'aws',
  Azure = 'azure',
};